// Placeholder file so the build process does not break
const PaymentSummary = () => {
  return null
}

export default PaymentSummary
